import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptorInterceptor } from './interceptors/http-interceptor.interceptor';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { StudioComponent } from './pages/studio/studio.component';
import { HomeLayoutComponent } from './layouts/home-layout.component';
import { EsignPositonComponent } from './pages/esign-positon/esign-positon.component';
import { PublicEsignComponent } from './pages/public-esign/public-esign.component';
import { EsignDocumentListComponent } from './pages/esign-document-list/esign-document-list.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { RedirectionFailureComponent } from './redirection-failure.component';
import { RedirectionSuccessComponent } from './redirection-success.component';
import { EsignDashboardComponent } from './pages/esign-dashboard/esign-dashboard.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    StudioComponent,
    HomeLayoutComponent,
    EsignPositonComponent,
    PublicEsignComponent,
    EsignDocumentListComponent,
    RedirectionFailureComponent,
    RedirectionSuccessComponent,
    EsignDashboardComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    PdfViewerModule,
  ],
   providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpInterceptorInterceptor,
        multi: true,
      },
      provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
